import { z } from 'zod'

import { AccountNiche } from '../recommendations/types'

export const recommendationsApiSchema = {
  personalizedRecommendationsData: {
    response: z.object({
      data: z.object({
        ig_niche_type: z.enum(AccountNiche).nullable(),
      }),
    }),
    path: z.undefined(),
    query: z.undefined(),
  },
}
